import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { LAURA_STAGES } from "@/app/components/laura/stages";
import type { LauraStageId } from "@/app/components/shared/types";
import { useTranslation } from "@/app/i18n/LocaleContext";
import { stageLabel } from "@/app/components/laura/stages";

const PLANNING_STAGES = LAURA_STAGES.filter((s) => s.phase === "planning");

type Props = {
    currentStage: LauraStageId;
    saiName?: string;
};

export function PlanningProgressHeader({ currentStage, saiName }: Props) {
    const { locale, t } = useTranslation();
    const currentIndex = PLANNING_STAGES.findIndex((s) => s.id === currentStage);
    const stepNumber = currentIndex < 0 ? 1 : currentIndex + 1;
    const progress = Math.round((stepNumber / PLANNING_STAGES.length) * 100);

    return (
        <Card className="py-3">
            <CardContent className="flex flex-col gap-3">
                <div className="flex flex-wrap items-center justify-between gap-2">
                    <div className="flex flex-wrap items-center gap-2">
                        <Badge variant="secondary">{t("laura", "p0PhasePlanning")}</Badge>
                        <span className="text-sm font-medium">
                            {stageLabel(currentStage, locale)}
                        </span>
                    </div>
                    {saiName && (
                        <Badge variant="outline">{saiName}</Badge>
                    )}
                </div>
                <div className="flex flex-col gap-1">
                    <div className="flex items-center justify-between text-xs text-muted-foreground">
                        <span>
                            {t("laura", "planningProgressStep", {
                                current: stepNumber,
                                total: PLANNING_STAGES.length,
                            })}
                        </span>
                        <span>{progress}%</span>
                    </div>
                    <Progress value={progress} />
                </div>
            </CardContent>
        </Card>
    );
}
